<template>
  <div id="main-wrap">
    <div id="main">
      <div
        :style="{
          height: `${pagesHeight}px`,
          overflow: 'hidden'
        }"
      >
        <div
          id="CoreCompetitiveness"
          :style="{
            width: '1920px',
            height: bodyHeight || '1080px',
            'transformOrigin':'left top',
            'transform':`scale(${scalseNum})`,
            '-webkit-transform':`scale(${scalseNum})`,
            '-moz-transform':`scale(${scalseNum})`,
            '-o-transform':`scale(${scalseNum})`,
            '-ms-transform':`scale(${scalseNum})`
          }"
        >
          <div class="main-header">
            <div class="header-left">
              <div class="site-name xx">
                {{ $route.meta.title === 'dynamic' ? dynamicTitle[$route.query.type] : $route.meta.title }}
              </div>
              <!-- <span
            v-if="showSelectDate"
            class="coocaa_btn xx"
            id="select-mounth"
            rightTarget="#index"
            rel="selectMonth"
            @click="selectMonth"
          >选择月份：{{ yearMonth }} <i class="el-icon-d-caret"></i></span> -->
              <span class="xx">数据统计时间至：{{ cutOffDate }}</span>
            </div>
            <div class="header-right" v-if="!isHideInMenu">
              <div class="nav">
                <ul>
                  <li
                    v-for="(item, key) in menu"
                    :key="key"
                    class="coocaa_btn"
                    :leftTarget="getNavLeftTarget(item.name)"
                    downTarget="#project_0"
                    :id="item.name"
                    rel="toNav"
                  >
                    <span
                      :src="`${item.path}`"
                      :routeName="item.path"
                      :class="{
                        curTab: iframeSrc === item.path
                      }"
                      @click="handleClickLink(item.path)"
                    >{{ item.meta.tab }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="header-right" v-else>
              <!-- <div class="return-page coocaa_btn" rel="back">返回 <span class="el-icon-arrow-right"></span></div> -->
              <div
                class="return-page coocaa_btn"
                rel="back"
                id="back"
                @click="handleBack"
              >
                返回 <span class="el-icon-arrow-right"></span>
              </div>
              <!-- <div
            class="return-page"
            v-else
            rel="back"

          >
            返回 <span class="el-icon-arrow-right"></span>
          </div> -->
            </div>
          </div>
          <div class="main-body" style="max-width:96rem;">
            <iframe width="100%" height="100%" :src="iframeSrc"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ccMapMixin from '@/mixins/ccmap'
import common from '@/mixins/common.js'
import scalseNum from '@/mixins/scalseNum.js'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  mixins: [ccMapMixin, common, scalseNum],
  components: {},
  props: {},
  data () {
    return {
      dynamicTitle: {
        closePic: '闭环率详情',
        directPic: '直客销售详情',
        recordPic: '销售效能详情'
      },
      prevId: '',
      keyCode: '',
      cutOffDate: '',
      showSelectDate: false, // 测试
      iframeSrc: 'https://databoard.coocaa.com/kanban-config-view?id=56'
    }
  },
  watch: {
    '$route.name': 'setShowSelectDate'
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    },
    isKeepAlive () {
      const meta = this.$route.meta
      return meta && meta.isCache !== false
    },
    isHideInMenu () {
      return this.$route.meta.hideInMenu
    },
    bodyHeight () {
      return this.$route.meta.bodyHeight || null
    },
    menu () {
      // return [...this.$router.options.routes[0].children.filter((item) => {
      //   return !item.meta.hideInMenu
      // })
      // // {
      // //   name: '财务经营业绩',
      // //   path: '/finance',
      // //   meta: {
      // //     title: '财务经营业绩',
      // //     tab: '财务经营业绩',
      // //     bodyHeight: 'auto'
      // //   }
      // // }
      // ]
      return [
        {
          name: '酷开系统',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=56',
          meta: {
            title: '酷开系统',
            tab: '酷开系统'
          }
        },
        {
          name: '酷开9',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=60',
          meta: {
            title: '酷开9',
            tab: '酷开9'
          }
        },
        {
          name: 'Coolita',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=62',
          meta: {
            title: 'Coolita',
            tab: 'Coolita'
          }
        },
        {
          name: '语音',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=63',
          meta: {
            title: '语音',
            tab: '语音'
          }
        },
        {
          name: 'IoT',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=64',
          meta: {
            title: 'IoT',
            tab: 'IoT'
          }
        },
        {
          name: 'Miitee',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=55',
          meta: {
            title: 'Miitee',
            tab: 'Miitee'
          }
        },
        // {
        //   name: '移动端',
        //   path: 'https://databoard.coocaa.com/kanban-config-view?id=60',
        //   meta: {
        //     title: '移动端',
        //     tab: '移动端'
        //   }
        // },
        // {
        //   name: '测试',
        //   path: 'http://beta-front-end.coocaa.com:8099/kanban-config-view?id=74&preview=true',
        //   meta: {
        //     title: '移动端',
        //     tab: '移动端'
        //   }
        // },
        {
          name: '大内容',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=57',
          meta: {
            title: '大内容',
            tab: '大内容'
          }
        },
        {
          name: '数字营销',
          path: 'https://databoard.coocaa.com/kanban-config-view?id=61',
          meta: {
            title: '数字营销',
            tab: '数字营销'
          }
        }
      ]
    },
    yearMonth () {
      return JSON.parse(sessionStorage.getItem('toggleDate')).time
    },
    month () {
      const date = new Date()
      return date.getMonth() + 1
    },
    ...mapGetters('router', {
      routerName: 'GetName'
    })
  },
  methods: {
    // handleTabShakeAnim (projectID, curIndex) {
    //   if (prevPanelId == 0 && (curIndex == 0 || curIndex == this.tabList.length - 1)) {
    //     console.log('Hi Guys, 准备抖动吧...', curIndex)
    //     $(`#tabIndex${curIndex}`).addClass('shakeAnim').one('animationend', function () {
    //       console.log('抖动完毕')
    //       $(`#tabIndex${curIndex}`).removeClass('shakeAnim')
    //     })
    //   }
    // },
    selectMonth () {
      localStorage.setItem('returnPage', location.pathname + location.search)
      location.href = '/select-month'
      // if (this.keyCode) {
      //   this.keyCode = 0
      // } else {
      //   // this.setRoute()
      //   this.$router.push({ name: 'select-month' })
      // }
    },
    setRoute () {
      const route = JSON.parse(this.$routeInfo('get'))
      this.$router.push({
        name: this.$route.name,
        query: this.$route.query
      })
      this.$routeInfo('set', JSON.stringify(route))
    },
    setCutOffDate () {
      const Time = JSON.parse(sessionStorage.getItem('toggleDate')).time.split('-')
      const selectYear = Time[0]
      const selectMonth = Time[1]
      if (this.month === parseInt(selectMonth) && +selectYear === +this.$dayjs().year()) {
        // this.cutOffDate = this.$cUtils.format.formatDate(new Date((new Date()).getTime() - 86400000), 'yyyy-MM-dd')
        this.cutOffDate = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      } else {
        this.cutOffDate = this.$cUtils.format.formatDate(new Date(selectYear, selectMonth, 0), 'yyyy-MM-dd')
      }
    },
    getNavLeftTarget (name) {
      if (name === 'index') {
        return '#select-mounth'
      }
    },
    handleClickLink (name) {
      this.iframeSrc = name
      // if (this.keyCode) {
      //   this.keyCode = 0
      // } else {
      //   if (name !== this.$route.name) {
      //     window.location = name
      //     // this.$router.push({ name })
      //   }
      // }
    },
    async onChangeTab (context, curTabId) {
      // console.log('onChangeTab:', this.prevId, curTabId)
      this.pageNum = parseInt(curTabId)
      if (this.prevId !== curTabId) {
        // 切换tab后需要rebind
        // bugfix：jquery和vue同时操作了真实dom，jquery添加btnFocus的操作会被覆盖，所以这里需要nextTick后处理，并在vue里添加btnFocus类
        // this.handleTabsScrollX(this.prevTabId, curTabId)

        await this.$nextTick()
        this.bindKey()

        // 处理边界阴影
        // this.handleTabsEdgeMask()
      } else {
        // this.handleTabShakeAnim(this.prevPanelId, curTabId)
      }
    },
    handleBack () {
      const returnPage = localStorage.getItem('returnPage')
      window.location = returnPage || '/'
      localStorage.removeItem('returnPage')
      // if (this.keyCode) {
      //   this.keyCode = 0
      // } else {
      //   this.$router.go(-1)
      //   // history.back(-1)
      //   // const routeInfo = this.$store.state.app.routeInfo
      //   // this.$router.push({
      //   //   name: routeInfo.name,
      //   //   query: routeInfo.query
      //   // })
      // }
      // location.href = '#/media-financial'
    },
    bindKey (target) {
      const getTarget = target ? '#' + target : null
      CCMap.init('.coocaa_btn', getTarget, 'btnFocus')
      const vm = this
      $('.coocaa_btn')
        .unbind()
        .bind('itemClick', function (e) {
          const rel = $(this).attr('rel')
          if (rel === 'back') {
            const returnPage = localStorage.getItem('returnPage')
            window.location = returnPage || '/'
            localStorage.removeItem('returnPage')
            // vm.$router.go(-1)
            // const routeInfo = vm.$store.state.app.routeInfo
            // vm.$router.push({
            //   name: routeInfo.name,
            //   query: routeInfo.query
            // })
            // location.href = '#/media-financial'
          }
          if (rel === 'ss_project') {
            const projectid = $(this).attr('dashboardId')
            const status = $(this).attr('status')
            if (status === '1') {
              vm.$store.dispatch('toggleRoute', {
                name: vm.$route.name,
                query: vm.$route.query
              })
              localStorage.setItem('returnPage', location.pathname + location.search)
              if (projectid) {
                window.location = `/kanban-config-view?id=${projectid}`
                // vm.$router.push({
                //   name: 'kanbanConfigView',
                //   query: {
                //     id: projectid
                //   }
                // })
              } else {
                window.location.href = `/ssp-project?id=20`
              }
            }
          }
          if (rel === 'digitalDetails') {
            localStorage.setItem('returnPage', location.pathname + location.search)
            location.href = $(this).attr('router')
            // vm.$router.push({
            //   name: $(this).attr('routerName'),
            //   query: JSON.parse($(this).attr('routerQuery'))
            // })
          }
          if (rel === 'selectMonth') {
            localStorage.setItem('returnPage', location.pathname + location.search)
            location.href = '/select-month'
          }
          const _depLink = $(this).attr('depLink')
          if (_depLink) {
            window.location = _depLink
          }
        })
        .bind('itemFocus', function (e) {
          // console.log('itemFocus..')
          const _tabHref = $(this).find('span').attr('src')
          const _tabId = $(this).attr('id')
          const rel = $(this).attr('rel')
          const routeName = $(this).find('span').attr('routeName')
          // if (this.isAndroid) {
          //   alert(_tabHref)
          // } else {
          //   console.log(_tabHref)
          // }
          if (_tabHref && rel) {
            if (window.location.pathname !== routeName) {
              window.location = routeName
            }
            // vm.$router.push({
            //   name: routeName
            // })
            // location.href = _tabHref
          }
          const _rel = $(this).attr('rel')
          if (_rel === 'ss_project') {
            const elTop = $(this).position().top
            const elHeight = $(this).height()
            const boxHeight = $('#ss_box').height()
            const scrollTop = $('#ss_box').scrollTop()
            if (elTop < 0) {
              if (Math.abs(elTop) > scrollTop) {
                $('#ss_box').scrollTop(0)
              } else {
                $('#ss_box').scrollTop(scrollTop + elTop)
              }
            }
            if (elTop > boxHeight) {
              const scrollHeight = elTop + elHeight - boxHeight + scrollTop
              $('#ss_box').scrollTop(scrollHeight)
            } else {
              if (elTop + elHeight > boxHeight) {
                const scrollHeight = elTop + elHeight - boxHeight + scrollTop
                $('#ss_box').scrollTop(scrollHeight)
              }
            }
            // console.log(elTop, elHeight, boxHeight)
          }
          _tabId && vm.onChangeTab(this, _tabId)
        }).bind('itemBlur', function (e) {
          const itemId = $(this).attr('id')
          // console.log('itemBlur..', itemId)
          vm.prevId = itemId
        })
    },
    setShowSelectDate (val, oldValue) {
      if (this.isAndroid) { // 如果是电视Android打开，只有首页可以选择月份开
        if (this.$route.name === 'index' || this.$route.meta.hideInMenu) {
          this.showSelectDate = true
        } else {
          this.showSelectDate = false
        }
      } else {
        this.showSelectDate = true
      }
    }
    // handleExitApp () {
    //   const _this = this
    //   document.onkeydown = function (e) {
    //     let key = window.event.keyCode
    //     _this.keyCode = key
    //     if ((key === 4 || key === 8)) {
    //       if (_this.$route.name === 'index') {
    //         alert('exit_app')
    //       } else {
    //         _this.$router.push({ name: 'index' })
    //       }
    //     }
    //   }
    // }
  },
  mounted () {
    this.bindKey(this.$route.name)
  },
  created () {
    // this.handleExitApp()
    this.setShowSelectDate()
  },
  activated () {
    this.setCutOffDate()
  }
}
</script>

<style lang="stylus" scoped>
#main-wrap
  width 100vw
  height 100vh
  overflow auto
#main
  transform-origin: left top;
.return-page
  background rgba(255, 255, 255, .1)
  color #fff
  font-size .8rem
  height 1.7rem
  padding 0 1rem
  margin-top .75rem
  border-radius .4rem
  cursor pointer
  .el-icon-arrow-right
    font-size 1rem
    font-weight bold
    vertical-align middle
.main-header
  background #1A1939
  height 3.2rem
  display flex
  padding  0 1rem
  .header-left
    font-size 1.2rem
    height 3.2rem
    line-height 3.2rem
    color #FFFFFF
    flex 1
    .xx
      float left
    .logo
      background-repeat no-repeat
    img
      display inline-block
      margin-right .3rem
      vertical-align text-bottom
      height 1.1rem
    span
      font-size .8rem
      color rgba(255,255,255,.6)
      padding-left .5rem
  .header-right
    height 1.6rem
    line-height 1.6rem
    font-size .9rem
.nav
  padding-top .7rem
  ul
    list-style none
    margin 0
    padding 0
    display flex
    justify-content flex-end
    li
      span
        color rgba(255,255,255,.4)
        padding 0 1rem
        box-sizing border-box
        line-height 1.8rem
        display block
        cursor pointer
.nav li span.curTab
  background #007EFF
  color #fff
  border-radius 10px
  // &:after
  //   content ''
  //   display block
  //   width 1.2rem
  //   height .15rem
  //   background #fff
  //   margin 0 auto
  //   border-radius 1rem
// .coocaa_btn.btnFocus
//   transition transform 0.2s linear
//   // transform scale(1.025, 1.025)
//   border-radius 8px
//   box-sizing border-box
//   background #007EFF
//   span
//     color rgba(255,255,255,1)
//     &:after
//       opacity 0
.main-body
  padding 1rem
  padding-bottom 0
  // margin-top 1rem
  // height calc(100vh - 4.2rem)
  // width calc(100vw - 2rem)
  // margin 1rem auto 0 auto
  // overflow hidden
#select-mounth
  border 1px solid rgba(255,255,255,.2)
  background none
  line-height 1.6rem
  margin-left .5rem
  margin-top .8rem
  padding-right .4rem
  border-radius .2rem
  cursor pointer
#select-mounth.btnFocus
  background #007EFF
  color #fff

#CoreCompetitiveness
  display: flex
  flex-direction: column
  position: relative
  .main-body
    flex-grow 1
  .main-header
    position absolute
    top 0
    left 0
    right 0
</style>
<style lang="stylus">
.coocaa_btn:not(.btnFocus) .coocaa_btn_hover
  opacity 0
.coocaa_btn.btnFocus .coocaa_btn_hover
  display block
  position absolute
  opacity 1
  transition opacity 0.2s linear
  // transform scale(1.025, 1.025)
  font-size 36px
  border-radius 10px
  box-sizing border-box
  width 100%
  height 100%
  border 3px solid #007EFF
  top 0
  left 0
</style>
